import React from 'react';
export function CardBrandsTable() {
  // Mock data with correct card brand icons
  const cardBrands = [{
    name: 'Visa',
    icon: 'https://raw.githubusercontent.com/aaronfagan/svg-credit-card-payment-icons/master/flat/visa.svg',
    count: 4500,
    volume: 250000,
    avgAmount: 55.56
  }, {
    name: 'MasterCard',
    icon: 'https://raw.githubusercontent.com/aaronfagan/svg-credit-card-payment-icons/master/flat/mastercard.svg',
    count: 3200,
    volume: 180000,
    avgAmount: 56.25
  }, {
    name: 'American Express',
    icon: 'https://raw.githubusercontent.com/aaronfagan/svg-credit-card-payment-icons/master/flat/amex.svg',
    count: 950,
    volume: 85000,
    avgAmount: 89.47
  }, {
    name: 'Discover',
    icon: 'https://raw.githubusercontent.com/aaronfagan/svg-credit-card-payment-icons/master/flat/discover.svg',
    count: 420,
    volume: 32000,
    avgAmount: 76.19
  }, {
    name: 'JCB',
    icon: 'https://raw.githubusercontent.com/aaronfagan/svg-credit-card-payment-icons/master/flat/jcb.svg',
    count: 230,
    volume: 15000,
    avgAmount: 65.22
  }];
  return <div className="overflow-x-auto" data-id="element-757">
      <table className="min-w-full divide-y divide-gray-200" data-id="element-758">
        <thead className="bg-gray-50" data-id="element-759">
          <tr data-id="element-760">
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-761">
              Card Brand
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-762">
              Transactions
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-763">
              Volume
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-764">
              Avg. Amount
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200" data-id="element-765">
          {cardBrands.map(brand => <tr key={brand.name} data-id="element-766">
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-767">
                <div className="flex items-center" data-id="element-768">
                  <div className="flex-shrink-0 h-8 w-12 flex items-center" data-id="element-769">
                    <img className="h-6 max-w-full" src={brand.icon} alt={brand.name} onError={e => {
                  // Fallback if image fails to load
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = `https://via.placeholder.com/60x40/f0f0f0/666666?text=${brand.name.charAt(0)}`;
                }} data-id="element-770" />
                  </div>
                  <div className="ml-4" data-id="element-771">
                    <div className="text-sm font-medium text-gray-900" data-id="element-772">
                      {brand.name}
                    </div>
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-773">
                {brand.count.toLocaleString()}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-774">
                Rs. {brand.volume.toLocaleString('en-LK')}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-775">
                Rs. {brand.avgAmount.toFixed(2)}
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}